// Инлайн-SVG иконки клиентского кабинета (в проекте нет icon-библиотек).
type IconProps = { size?: number; color?: string };

function base(size: number | undefined) {
  return {
    width: size ?? 24,
    height: size ?? 24,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true,
  };
}

export function HomeIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size)} style={color ? { color } : undefined}>
      <path d="M3 10.5 12 3l9 7.5" />
      <path d="M5 9.5V21h14V9.5" />
      <path d="M9.5 21v-6h5v6" />
    </svg>
  );
}

export function BagIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size)} style={color ? { color } : undefined}>
      <path d="M5 8h14l-1 13H6L5 8Z" />
      <path d="M8.5 10V6.5a3.5 3.5 0 0 1 7 0V10" />
    </svg>
  );
}

export function WalletIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size)} style={color ? { color } : undefined}>
      <rect x="3" y="6" width="18" height="14" rx="2" />
      <path d="M3 10h18" />
      <path d="M16 15h2" />
    </svg>
  );
}

export function ChartIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size)} style={color ? { color } : undefined}>
      <path d="M4 20V10" />
      <path d="M10 20V4" />
      <path d="M16 20v-7" />
      <path d="M21 20H3" />
    </svg>
  );
}

export function UserIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size)} style={color ? { color } : undefined}>
      <circle cx="12" cy="8" r="4" />
      <path d="M4.5 20.5c1.5-3.5 4.5-5 7.5-5s6 1.5 7.5 5" />
    </svg>
  );
}

export function NewsIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size)} style={color ? { color } : undefined}>
      <rect x="3" y="5" width="15" height="15" rx="2" />
      <path d="M18 9h1.5a1.5 1.5 0 0 1 1.5 1.5V18a2 2 0 0 1-2 2H5" />
      <path d="M7 9.5h7M7 13h7M7 16.5h4" />
    </svg>
  );
}

export function ChevronRightIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size ?? 18)} style={color ? { color } : undefined}>
      <path d="m9 5 7 7-7 7" />
    </svg>
  );
}

export function BellIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size ?? 18)} style={color ? { color } : undefined}>
      <path d="M6 9a6 6 0 0 1 12 0c0 4 1.5 5.5 2 6H4c.5-.5 2-2 2-6Z" />
      <path d="M10 18a2 2 0 0 0 4 0" />
    </svg>
  );
}

export function MailIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size ?? 18)} style={color ? { color } : undefined}>
      <rect x="3" y="5.5" width="18" height="13" rx="2" />
      <path d="m4 7 8 6 8-6" />
    </svg>
  );
}

export function LayersIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size)} style={color ? { color } : undefined}>
      <path d="m12 3 9 5-9 5-9-5 9-5Z" />
      <path d="m3.5 12.5 8.5 4.7 8.5-4.7" />
      <path d="m3.5 16.8 8.5 4.7 8.5-4.7" />
    </svg>
  );
}

export function TruckIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size)} style={color ? { color } : undefined}>
      <path d="M3 7.5a1.5 1.5 0 0 1 1.5-1.5H14v10H3V7.5Z" />
      <path d="M14 10h3.4a1.5 1.5 0 0 1 1.25.67L21 14v2h-7v-6Z" />
      <circle cx="7.5" cy="17.5" r="1.8" />
      <circle cx="17" cy="17.5" r="1.8" />
    </svg>
  );
}

export function CheckCircleIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size)} style={color ? { color } : undefined}>
      <circle cx="12" cy="12" r="9" />
      <path d="m8.2 12.2 2.6 2.6 5-5.4" />
    </svg>
  );
}

export function SearchIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size ?? 18)} style={color ? { color } : undefined}>
      <circle cx="11" cy="11" r="6.5" />
      <path d="m16 16 4 4" />
    </svg>
  );
}

export function CalendarIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size ?? 18)} style={color ? { color } : undefined}>
      <rect x="3.5" y="5" width="17" height="15" rx="2" />
      <path d="M3.5 9.5h17" />
      <path d="M8 3.5V6M16 3.5V6" />
    </svg>
  );
}

export function ChevronDownIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size ?? 18)} style={color ? { color } : undefined}>
      <path d="m5 9 7 7 7-7" />
    </svg>
  );
}

export function BoxIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size)} style={color ? { color } : undefined}>
      <path d="M12 3.2 20.5 7.6v8.8L12 20.8 3.5 16.4V7.6L12 3.2Z" />
      <path d="M3.5 7.6 12 12l8.5-4.4" />
      <path d="M12 12v8.8" />
    </svg>
  );
}

export function ChatIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size)} style={color ? { color } : undefined}>
      <path d="M4 5.5h16v11H9l-5 4v-15Z" />
      <path d="M8.5 11h.01M12 11h.01M15.5 11h.01" />
    </svg>
  );
}

export function DocumentIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size)} style={color ? { color } : undefined}>
      <path d="M6 3.5h7.5L19 9v11.5H6V3.5Z" />
      <path d="M13.5 3.5V9H19" />
      <path d="M9 13h7M9 16.5h5" />
    </svg>
  );
}

export function TrashIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size ?? 18)} style={color ? { color } : undefined}>
      <path d="M4.5 6.5h15" />
      <path d="M9.5 6.5V4.5h5v2" />
      <path d="M6.5 6.5 7.5 20h9l1-13.5" />
      <path d="M10.5 10v6M13.5 10v6" />
    </svg>
  );
}

export function SendIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size ?? 18)} style={color ? { color } : undefined}>
      <path d="M20.5 3.5 3.5 10.2l6.6 2.7 2.7 6.6L20.5 3.5Z" />
      <path d="m10.1 12.9 4.1-4.1" />
    </svg>
  );
}

export function PlusIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size ?? 18)} style={color ? { color } : undefined}>
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
}

export function MinusIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size ?? 18)} style={color ? { color } : undefined}>
      <path d="M5 12h14" />
    </svg>
  );
}

export function CartIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size ?? 18)} style={color ? { color } : undefined}>
      <path d="M2.5 4h2.2l2.3 10.5h10L20 7H6" />
      <circle cx="9.5" cy="19" r="1.6" />
      <circle cx="16.5" cy="19" r="1.6" />
    </svg>
  );
}

export function ArrowLeftIcon({ size, color }: IconProps) {
  return (
    <svg {...base(size ?? 18)} style={color ? { color } : undefined}>
      <path d="M19 12H5" />
      <path d="m11 6-6 6 6 6" />
    </svg>
  );
}
